/* eslint-disable max-len */
export default {
  /**
   * @param {{ directive: (arg0: string, arg1: { inserted(el: HTMLFormElement, binding: object): void; update(el: HTMLFormElement, binding: object): void; }) => void; }} Vue
   */
  install(Vue) {
    Vue.directive('focus', {
      /**
       * @param {HTMLFormElement} el
       * @param {{ value: any; modifiers: object; }} binding
       */
      inserted(el, binding) {
        const { modifiers, value } = binding;

        if (value || value === undefined) {
          el.focus();
          if (modifiers.select) {
            el.select();
          }
        }
      },
      /**
       * @param {HTMLFormElement} el
       * @param {{ oldValue: any; value: any; }} binding
       */
      update(el, binding) {
        const { oldValue, value } = binding;
        if (value && value !== oldValue) {
          el.focus();
        }
      },
    });
  },
};



// WEBPACK FOOTER //
// ./_source/plugins/focus.js